export default __webpack_public_path__ + "static/media/person_2.223f1f20.png";